export default __webpack_public_path__ + "static/media/icon_skill_fist.6796adaf.png";